export const defaultEnvironments = ['ProdEnv', 'OnbEnv', 'PTLand', 'PTEnv0445bedbath'];
export const protocols = ['AS2', 'SFTP', 'partnerSFTP'];
export const usesNewIpsOptions = ['', 'true', 'false'];
export const isEnabledOptions = ['', 'true', 'false'];
